exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-projekti-tsx": () => import("./../../../src/pages/projekti.tsx" /* webpackChunkName: "component---src-pages-projekti-tsx" */),
  "component---src-pages-storitve-tsx": () => import("./../../../src/pages/storitve.tsx" /* webpackChunkName: "component---src-pages-storitve-tsx" */)
}

